// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".save-button.disabled[data-v-85157e26]{cursor:not-allowed;opacity:0.5}\n", ""]);
// Exports
module.exports = exports;
